
import Hero from './components/Hero';
import About from './components/About';
import Mining from './components/Mining';
import Logistics from './components/Logistics';

export default function HomePage() {
  return (
    <>
      <Hero />
      <About />
      <Mining />
      <Logistics />
    </>
  );
}
